<template>
	<!-- Page Container -->
	<div class="page-container">
	  <!-- Main -->
	  <main class="main magazine">
	  	<section id="magazine">
	        <div class="ticker bg-pink loaded" data-title="Magazine">
	            <div>
	            	<marquee-text :duration="60">
	            	  <h3 class="ticker-item fs-normal">Magazine</h3>
	            	  <span class="ticker-item performa fs-normal">Performa</span>
	            	  <span class="ticker-item fs-normal">Magazine</span>
	            	  <span class="ticker-item performa fs-normal">Performa</span>
	            	</marquee-text>
	            </div>
	        </div>
	        
	        
	        <div class="section-wrap magazine-wrap">
		        <div class="grid-container c3 query-options">
			        <div class="sort-by">
				        <label>Sort by</label>
				        <select v-model="sort" @change="getContent(tag, sort)" name="filters">
					        <option value="newest" selected>Newest</option>
								  <option value="oldest">Oldest</option>
								</select>
			        </div>
			        
			        <div class="filters">
				        <label>Filter by</label>
				        <select v-model="tag" @change="getContent(tag, sort)" name="filters">
					        <option value="all" selected>All</option>
								  <option value="reports">Reports</option>
								  <option value="in-conversation">In Conversation</option>
								  <option value="features">Features</option>
								  <option value="essays">Essays</option>
								</select>
			        </div>
					<div class="search">
						<form @submit.prevent="filterSearchTerm">
			  				<input type="text" placeholder="search" v-model="searchTerm" />
			  				<button @click.prevent="filterSearchTerm" type="submit">→</button>
			  			</form>
					</div>
		        </div>
            <div class="grid-container c3 list-articles">
	            <ArticleItem v-for="(item, index) in filteredArticles" :key="item.id" :article="item">
				</ArticleItem>
            </div>
	        </div>
	        
	        <div class="section-wrap pagination">
		        
		        
						  <paginate
						    v-model="current_page"
						    :page-count="total_pages"
						    :page-range="3"
						    :margin-pages="2"
						    :click-handler="clickCallback"
						    :prev-text="'⟵'"
						    :next-text="'⟶'"
						    :container-class="'pagination'"
						    :page-class="'page-item'">
						  </paginate>
			
		         
	        </div>
	   </section>     
	  </main>
	</div>

</template>

<script>	
import moment from 'moment'
import Paginate from 'vuejs-paginate'
import ArticleItem from '../components/ArticleItem.vue'

const toggleClass = function (target, addRemoveClass, className) {
  if (addRemoveClass === 'addClass') {
    target.classList.add(className);
  } else {
    target.classList.remove(className);
  }
}

export default {
  name: 'Magazine',
  components: {
	  ArticleItem,
	  Paginate
  },
  metaInfo () {
    return {
      title: this.fields.title
    }
  },
  metaInfo () {
	  
	  if (this.description == null) {
		  var description = 'Founded by RoseLee Goldberg in 2004, Performa is the leading organization dedicated to exploring the critical role of live performance in the history of twentieth-century art and to encouraging new directions in performance for the twenty-first century.';
	  } else {
		  	  var description = this.description;
	  }
	  	  
    return {
      title: this.fields.title,
      meta: [
		    {vmid: 'description', name: 'description', content: description},
		    
		    {vmid: 'og:title', property: 'og:title', content: this.fields.title},
		    {vmid: 'og:site_name', property: 'og:site_name', content: 'Performa'},
		    // The list of types is available here: http://ogp.me/#types
		    {vmid:'og:type', property: 'og:type', content: 'website'},
		    // Should be the the same as your canonical link, see below.
		    {vmid:'og:url', property: 'og:url', content: 'https://performa-arts.org/magazine/'},
		    // Often the same as your meta description, but not always.
		    {vmid:'og:description', property: 'og:description', content: description},
		    
		
		    {vmid: 'twitter:card', name: 'twitter:card', content: 'summary'},
		    {vmid: 'twitter:site', name: 'twitter:site', content: 'https://performa-arts.org/magazine/'},
		    {vmid: 'twitter:title', name: 'twitter:title', content: this.fields.title},
		    {vmid: 'twitter:description', name: 'twitter:description', content: description},
		    {vmid: 'twitter:creator', name: 'twitter:creator', content: '@PerformaNYC'},		
		    {vmid: 'itemprop-name', itemprop: 'name', content: this.fields.title},
		    {vmid: 'itemprop-description', itemprop: 'description', content: description}
		  ]
    }
  },
  data () {
    return {
	    today: null,
      fields: {
        title: 'Magazine'
      },
      tag: 'all',
      sort: 'newest',
      total_pages: 0,
      total: null,
      per_page: 12,
      current_page: 1,
	  articles: [],
	  searchTerm: ''
    }
  },
  computed: {
	  filteredArticles () {
		const filteredArticles = [...this.articles];
		return filteredArticles.filter(article => article.data.title.toLowerCase().includes(this.searchTerm.toLowerCase()))
	  }
  },
	methods: {
		filterSearchTerm () {
			if (!this.searchTerm.length) return;
		},

		clickCallback (page) {
      console.log(page);
      this.$ga.event('Magazine', 'pagination-click');
      this.getContent(this.tag, this.sort);
    },
	  getContent (tag, sort) {
		  if (tag == 'all' && sort == 'newest') {
			  this.$prismic.client.query(
				  this.$prismic.Predicates.at('document.type', 'article'),
				{ orderings : '[my.article.date desc]', pageSize : this.per_page, page : this.current_page }
				).then((response) => {
					this.total_pages = response.total_pages;
					this.total = response.total_results_size;
					this.per_page = response.results_per_page;
					this.current_page = response.page;
				  this.articles = response.results;
				  console.log(response);
				})
		  }	else if (tag == 'all' && sort == 'oldest') {
			  this.$prismic.client.query(
				  this.$prismic.Predicates.at('document.type', 'article'),
				{ orderings : '[my.article.date]', pageSize : this.per_page, page : this.current_page }
				).then((response) => {
					this.total_pages = response.total_pages;
					this.total = response.total_results_size;
					this.per_page = response.results_per_page;
					this.current_page = response.page;
				  this.articles = response.results;
				  console.log(response);
				})
				
			}	else if (sort == 'oldest') {
			  this.$prismic.client.query([
				  this.$prismic.Predicates.at('document.type', 'article'),
				  this.$prismic.Predicates.at('document.tags', [tag])
				], { orderings : '[my.article.date]', pageSize : this.per_page, page : this.current_page }
				).then((response) => {
					this.total_pages = response.total_pages;
					this.total = response.total_results_size;
					this.per_page = response.results_per_page;
					this.current_page = response.page;
				  this.articles = response.results;
				  console.log(response);
				})
		  } else if (sort == 'newest') {
			  this.$prismic.client.query([
				  this.$prismic.Predicates.at('document.type', 'article'),
				  this.$prismic.Predicates.at('document.tags', [tag])
				], { orderings : '[my.article.date desc]', pageSize : this.per_page, page : this.current_page }
				).then((response) => {
					this.total_pages = response.total_pages;
					this.total = response.total_results_size;
					this.per_page = response.results_per_page;
					this.current_page = response.page;
				  this.articles = response.results;
				  console.log(response);
				})
		  }
		  this.$ga.event('MagazineFilters', tag)
	  }
	},
	created () {
	  this.getContent(this.tag, this.sort);
  },
  mounted() {
	  setTimeout(function() {
			toggleClass(document.body, 'addClass', 'loaded');
		}, 500);
  }
}
</script>

<style scoped>
	.search {
		padding: 1rem;
		position: relative;
	}

	.search input {
		border: none;
		border-bottom: 1px solid black;
		padding: 0 0 0.5rem 0;
		color: black !important;
		margin-bottom: 0;
		
	}

	.search input:active, .search input:focus {
		border-bottom: 1px solid black;
	}

	.search input::placeholder {
		color: black;
		opacity: 0.7;
		text-transform: capitalize;
	}

	.search button {
		/* content: "→"; */
		display: block;
		font-size: 2rem;
		position: absolute;
		color: black;
		right: 1rem;
		top: 4px;
		cursor: pointer;
		transition: all 150ms cubic-bezier(0.075, 0.82, 0.165, 1);
		background-color: transparent;
		border: none;
		outline: none;
	}

	button:hover {
		opacity: 0.7;
	}

	.query-options .filters, .query-options .search {
		border-top: 2px solid black !important;
		border-bottom: 2px solid black;
	}

	.query-options div:first-child {
		border-right: 2px solid black;
	}

	.query-options .filters {
		border-right: 2px solid black;
	}

	@media screen and (max-width: 969px) {
		.query-options .sort-by, .query-options .filters, .query-options .search {
			border-top: 2px solid black !important;
			/* border-bottom: none; */
			border-bottom: none !important;
			border-right: none !important;
		}
		
		.query-options .search {
			border-bottom: 2px solid black !important;
		}
	}
</style>